// client/src/lib/api.js

const RAW_BASE =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_API_BASE ||
  process.env.REACT_APP_RENDER_BASE ||
  "";

// Normalize base: trim trailing slashes and remove trailing "/api" if someone included it in env.
function normalizeBase(base) {
  if (!base) return "";
  let b = String(base).trim();
  b = b.replace(/\/+$/, "");     // trim trailing /
  b = b.replace(/\/api$/i, "");  // trim trailing /api
  return b;
}

const ORIGIN = normalizeBase(RAW_BASE);

// Always build API URLs under /api (exactly once)
function buildUrl(path) {
  const p0 = String(path || "");
  const p1 = p0.startsWith("/") ? p0 : `/${p0}`;
  const p = p1.startsWith("/api/") ? p1 : `/api${p1}`;

  // If no env base is set, use relative calls (works with Vercel rewrites/proxy if you have them)
  if (!ORIGIN) return p;

  return `${ORIGIN}${p}`;
}

/** GET JSON that never throws on bad JSON; returns uniform shape */
export async function getJSON(path, fetchOptions = {}) {
  const url = buildUrl(path);
  const resp = await fetch(url, {
    method: "GET",
    headers: { Accept: "application/json" },
    mode: "cors",
    credentials: "omit",
    ...fetchOptions,
  });

  const raw = await resp.text();
  try {
    const data = raw ? JSON.parse(raw) : null;
    return { ok: resp.ok, status: resp.status, data, text: raw };
  } catch {
    return { ok: false, status: resp.status, error: "bad_json", text: raw };
  }
}

export const api = {
  // Expose what origin we think we’re using (helpful for debugging)
  base: ORIGIN ? `${ORIGIN}/api` : "/api",

  // streams
  streams: () => getJSON("/streams"),
  stream: (id) => getJSON(`/streams/${encodeURIComponent(id)}`),

  // merch
  merch: {
    health: () => getJSON("/merch/health"),
    products: () => getJSON("/merch/products"),
    product: (id) => getJSON(`/merch/product/${encodeURIComponent(id)}`),
  },

  // affiliates
  affiliates: () => getJSON("/affiliates"),
};

export default api;
